import React from 'react';
import JobSingle from './JobSingle';

//api calls
import jobstreamurl from '../api/jobs.js'
import axios from 'axios'

class App extends React.Component {

  state = {
    jobId: '',
    jobs: [],
    socialshares: [],
    SingleJobselectionData: [],
  }

  constructor(props) {
    super(props);
    this.state = {
      jobId: props.jobId,
      SingleJobselectionData: props.SingleJobselectionData,
    };
  }

  componentDidMount() {
    this.fetchJobstreamUrl();
  }

  fetchJobstreamUrl = async () => {
    this.setState({
      jobstreamurl: "",
    },
      this.fetchAllData
    );
  }

  fetchJobs = async (id) => {
    const pathName = `${window.es_var.pathName}`;
    var URL = '';
    if (pathName) {
      URL = '/' + pathName + "/wp-json/macs/v1/single-job-api" + '?cg_job_id=' + this.state.jobId;
    } else {
      URL = "/wp-json/macs/v1/single-job-api" + '?cg_job_id=' + this.state.jobId;
    }
    const response = await axios.get(
      URL
    ).then(response =>
      this.setState({
        jobs: response.data,
      },
        this.fetchSocialShareIcons
      )
    );
  }

  fetchAllData = async () => {
    this.fetchJobs();
  }

  fetchSocialShareIcons = async () => {
    const response = await axios.get(
      '/wp-json/macs/v1/socialshareurls'
    ).then(response =>
      this.setState({
        socialshares: response.data,
      })
    );
  }

  render() {
    return (
      <div className="single-job">
        {((typeof this.state.jobs === 'undefined' || (this.state.jobs._id !== undefined && this.state.jobs.deleted_at !== null))) ? (
          <div></div>
        ) : (
          <React.Fragment>
            <JobSingle jobs={this.state.jobs} socialshares={this.state.socialshares} SingleJobselectionData={this.state.SingleJobselectionData} />
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default App;
